import React, { useMemo, useState } from 'react';
import {
  CANALES_COPILOTO,
  CANAL_LABELS,
  getConversacionStats,
  labelFromCatalog,
  parseConversacionPegada,
  ROL_CONVERSACION_LABELS,
  ROLES_CONVERSACION,
} from '../../../services/copilotoComercialService';

const NUEVO_MENSAJE = {
  rol: 'PROSPECTO',
  texto: '',
  fechaHora: '',
};

export default function ConversacionPegadaEditor({
  form,
  mensajes,
  onFormChange,
  onMensajesChange,
  proyectos = [],
  desarrollos = [],
  disabled = false,
  onAnalyze,
}) {
  const [textoPegado, setTextoPegado] = useState('');
  const stats = useMemo(() => getConversacionStats(mensajes), [mensajes]);
  const errorLimites = stats.excedeMensajes
    ? 'La conversacion supera el limite de 100 mensajes.'
    : stats.excedeCaracteresPorMensaje
      ? 'Uno o mas mensajes superan 2,000 caracteres.'
      : '';

  const updateForm = (event) => {
    const { name, value } = event.target;
    onFormChange({ ...form, [name]: value });
  };

  const procesarTexto = () => {
    onMensajesChange(parseConversacionPegada(textoPegado));
  };

  const updateMensaje = (index, patch) => {
    onMensajesChange(mensajes.map((mensaje, itemIndex) => (itemIndex === index ? { ...mensaje, ...patch } : mensaje)));
  };

  const eliminarMensaje = (index) => {
    onMensajesChange(mensajes.filter((_, itemIndex) => itemIndex !== index));
  };

  const agregarMensaje = () => {
    onMensajesChange([...mensajes, NUEVO_MENSAJE]);
  };

  return (
    <section className="crm-prospectos-card copiloto-card">
      <div className="crm-prospectos-section-head">
        <div>
          <h2>Conversacion a analizar</h2>
          <p className="copiloto-help">Pega aqui el texto de la conversacion. Puedes incluir mensajes del prospecto y del asesor.</p>
        </div>
        <button type="button" className="is-primary" onClick={onAnalyze} disabled={disabled || mensajes.length === 0 || Boolean(errorLimites)}>
          {disabled ? 'Analizando conversacion...' : 'Procesar conversacion'}
        </button>
      </div>

      <div className="crm-prospectos-form-grid">
        <label>
          <span>Canal</span>
          <select name="canal" value={form.canal} onChange={updateForm} disabled={disabled} required>
            {CANALES_COPILOTO.map((canal) => (
              <option key={canal} value={canal}>{labelFromCatalog(CANAL_LABELS, canal)}</option>
            ))}
          </select>
        </label>
        <label>
          <span>Campana / anuncio de origen</span>
          <input name="campanaOrigen" value={form.campanaOrigen} onChange={updateForm} disabled={disabled} />
        </label>
        <label>
          <span>Proyecto</span>
          <select name="proyectoId" value={form.proyectoId} onChange={updateForm} disabled={disabled}>
            <option value="">Sin proyecto</option>
            {proyectos.map((proyecto) => <option key={proyecto.id} value={proyecto.id}>{proyecto.nombre}</option>)}
          </select>
        </label>
        <label>
          <span>Desarrollo</span>
          <select name="desarrolloId" value={form.desarrolloId} onChange={updateForm} disabled={disabled}>
            <option value="">Sin desarrollo</option>
            {desarrollos.map((desarrollo) => <option key={desarrollo.id} value={desarrollo.id}>{desarrollo.nombre}</option>)}
          </select>
        </label>
        <label className="is-wide">
          <span>Nombre del prospecto</span>
          <input value={form.nombreProspecto} disabled readOnly />
        </label>
        <label className="is-full">
          <span>Texto pegado</span>
          <textarea
            value={textoPegado}
            onChange={(event) => setTextoPegado(event.target.value)}
            rows="7"
            disabled={disabled}
            placeholder="Prospecto: Hola, me interesa la casa."
          />
        </label>
      </div>

      <div className="copiloto-toolbar">
        <button type="button" onClick={procesarTexto} disabled={disabled || !textoPegado.trim()}>Convertir a mensajes</button>
        <button type="button" onClick={agregarMensaje} disabled={disabled || mensajes.length >= 100}>Agregar mensaje</button>
        <span>{stats.mensajes} mensajes · {stats.caracteres} caracteres</span>
      </div>
      {errorLimites ? <p className="crm-prospectos-feedback is-error">{errorLimites}</p> : null}

      <div className="copiloto-mensajes-list">
        {mensajes.length === 0 ? <p className="crm-prospectos-empty">Convierte el texto pegado o agrega mensajes manualmente.</p> : null}
        {mensajes.map((mensaje, index) => (
          <article key={`${index}-${mensaje.rol}`} className="copiloto-mensaje-row">
            <label>
              <span>Rol</span>
              <select value={mensaje.rol} onChange={(event) => updateMensaje(index, { rol: event.target.value })} disabled={disabled}>
                {ROLES_CONVERSACION.map((rol) => (
                  <option key={rol} value={rol}>{labelFromCatalog(ROL_CONVERSACION_LABELS, rol)}</option>
                ))}
              </select>
            </label>
            <label className="is-wide">
              <span>Mensaje</span>
              <textarea value={mensaje.texto} onChange={(event) => updateMensaje(index, { texto: event.target.value.slice(0, 2000) })} disabled={disabled} rows="2" />
            </label>
            <label>
              <span>Fecha</span>
              <input type="datetime-local" value={mensaje.fechaHora} onChange={(event) => updateMensaje(index, { fechaHora: event.target.value })} disabled={disabled} />
            </label>
            <button type="button" className="is-danger" onClick={() => eliminarMensaje(index)} disabled={disabled}>Eliminar</button>
          </article>
        ))}
      </div>
    </section>
  );
}
